// extracted by mini-css-extract-plugin
export default {"container":"Grsh5ETwUyW4unyK1HDx","image":"M43OB4jpmkIuwiYuCsAX","description":"Dt5Ncq_jpgpCoW_pmwWO","primaryText":"iOVscgeELBupmlsYacOo","line":"njRsma2p3vkbaN3WkCsb"};